import QRCode from "qrcode.react";
import React, { useEffect, useRef } from "react";
import { useLocale } from "../../../contexts/localeContext";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { useFormikContext } from "formik";
import { getErrorMessage } from "../../../services/utilities/ServiceError";
import { useDialog } from "../../dialog/DialogContext";
import { genericError } from "../../../models/GenericError";

interface Props {
    cardCode: string,
    setImage: (img: string) => void
}
const GenerateQRCode = ({ cardCode, setImage }: Props) => {

    const { translate } = useLocale();
    const { setValues } = useFormikContext<any>();
    const dialog = useDialog();

    const qrCodeContainerRef = useRef<HTMLDivElement | null>(null);

    const convertQRCodeToBase64 = () => {
        const qrCodeEl = qrCodeContainerRef.current?.children[0] as HTMLCanvasElement | undefined;

        // If we can't find the QR code canvas element, log an error and abort the function.
        if (!qrCodeEl) {
            dialog.pushError({ title: translate.byKey(TranslationKeys.error), message: getErrorMessage(genericError) })
            return;
        }

        // Generate a data URL for the QR code image. This URL is the base64 representation of the image.
        const qrCodeDataURL = qrCodeEl.toDataURL("image/png");

        return qrCodeDataURL;
    }

    useEffect(() => {
        setValues(state => ({
            ...state, ['code']: cardCode
        }))
        
        const timeoutId = setTimeout(() => {
            const base64Image = convertQRCodeToBase64();
            base64Image && setImage(base64Image)
        }, 200);
        // Clean up the timeout if the component unmounts before the timeout fires
        return () => clearTimeout(timeoutId);

    }, [cardCode])

    return (
        <div className="p-2 mt-3" ref={qrCodeContainerRef}>
            <QRCode
                size={160}
                value={cardCode}
                renderAs="canvas"
            />
        </div>
    )
}

export default GenerateQRCode;